type BrTextProps = {
  className?: string;
  children: string;
};

/**
 * This replaces simple span for displaying pure text with added functionalities:
 *   - The dir attribute is set to "auto" so that both LTR & RTL (Arabic, Hebrew) can be correctly displayed.
 */
export default function BrText(props: BrTextProps): JSX.Element {
  const { className, children, ...otherProps } = props;
  return (
    <span className={className} dir="auto" {...otherProps}>
      {children}
    </span>
  );
}
